import { GraviButton, MaterialIcon } from '@gravitate-js/excalibrr'
import { useQueryClient } from '@tanstack/react-query'
import { Tooltip, notification } from 'antd'
import { useState } from 'react'
import type { InvoiceGroup } from '../../../../../../api/useFreight/types'
import { useInvoices } from '../../../../../../api/useFreight/useInvoices'

export function SendButton({ invoiceGroup }: { invoiceGroup: InvoiceGroup }) {
  const { useSendInvoiceMutation } = useInvoices()
  const sendInvoiceMutation = useSendInvoiceMutation()
  const queryClient = useQueryClient()
  const [loading, setLoading] = useState(false)
  const isOnHold = invoiceGroup.status === 'hold'

  const handleSendInvoice = async () => {
    setLoading(true)
    await sendInvoiceMutation.mutateAsync({
      invoice_group_id: invoiceGroup.id,
    })

    queryClient.invalidateQueries({ queryKey: ['invoice'] })
    queryClient.invalidateQueries({ queryKey: ['invoices-be-query'] })
    notification.success({
      message: 'Invoice Sent Successfully',
      description: `Invoice has been sent to ${invoiceGroup.counterparty_name}.`,
      placement: 'topRight',
      icon: <MaterialIcon icon='check_circle' style={{ color: 'var(--theme-success)' }} />,
    })
    setLoading(false)
  }

  return (
    <Tooltip title={isOnHold ? 'Remove hold to send' : ''}>
      <div style={{ width: '100%' }}>
        <GraviButton
          color='primary'
          style={{ fontWeight: 'bold', width: '100%' }}
          buttonText='Send'
          icon={<MaterialIcon icon='send' className='pt-1' />}
          onClick={handleSendInvoice}
          loading={loading}
          disabled={isOnHold}
        />
      </div>
    </Tooltip>
  )
}
